/* RESPONSIBLE TEAM: team-messenger */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default Fragment.extend({
  activeTeammates: attr(),
});
